export const getSetores = (state) => state.setores.lista
export const getIsCarregandoListaSetores = (state) => state.setores.isCarregandoLista
